<div class="wrapper" name="{{langStringCtrl.name}}" ng-model="langStringCtrl.model" c-lang-string-required="langStringCtrl.validation.required">
    <input type="text" autocomplete="off" ng-model="langStringCtrl.localizationValue" ng-click="langStringCtrl.inputClicked()"/>
    <i class="fa fa-edit" ng-click="langStringCtrl.edit()"></i>
</div>
<div ng-messages="langStringCtrl.error" class="error-text">
    <div ng-message="langStringRequired">
        {{langStringCtrl.requiredMessage}}
    </div>
</div>